import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'fi-page-section-error',
    templateUrl: 'page-section-error.component.html',
    styleUrls: ['page-section-error.component.scss'],
    standalone: false,
})
export class PageSectionErrorComponent implements OnInit {
    @Input() pageSection;
    @Input() selectedKey;

    constructor() {}

    isShowError() {
        return (
            (this.pageSection.error === 'function' ? this.pageSection.error() : this.pageSection.error) &&
            this.selectedKey != (this.pageSection.key || this.pageSection.Name)
        );
    }

    ngOnInit() {}
}
